import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {LocalStorageAssistantRepository} from '../Repositories/LocalStorageAssistantRepository.js'

class SaveAssistantChatUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new SaveAssistantChatUseCase({
      repository: LocalStorageAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'SaveAssistantChatUseCase#execute'})
  @AsyncInlineError()
  async execute({chatId, content} = {}) {
    this.#repository.saveActiveChat({chatId, content})
  }
}

export const factory = SaveAssistantChatUseCase.create
